
import { defineComponent, PropType, ref } from "vue"
import HubWebinar from "@/models/hub/HubWebinar"
import PopUpSection from "@/components/HubGridComponents/PopUpSection.vue"
export default defineComponent({
  components: { PopUpSection },
  props: {
    webinar: { type: Object as PropType<HubWebinar>, required: true },
    shouldLoad: { type: Boolean, required: true, default: false }
  },
  setup(props) {
    let isHovering = ref(false)
    let getHovering = () => isHovering
    return { isHovering, getHovering }
  },
  methods: {
    naviateToLP(url: string) {
      window.location.assign(url)
    },
    onmouseenter() {
      this.isHovering = true
    },
    onmouseout() {
      this.isHovering = false
    }
  }
})
